const LOCAL_INTERNAL_APP_URL = "http://localhost:5173";

function normalizeUrl(url: string) {
  return url.replace(/\/+$/, "");
}

export function resolveInternalAppUrl(currentUrl?: string) {
  const rawUrl =
    currentUrl ||
    (typeof window !== "undefined" ? window.location.href : LOCAL_INTERNAL_APP_URL);

  try {
    const parsed = new URL(rawUrl);

    if (parsed.hostname === "localhost" || parsed.hostname === "127.0.0.1") {
      return LOCAL_INTERNAL_APP_URL;
    }

    const segments = parsed.hostname.split(".");
    if (segments.length > 1) {
      segments[0] = "app";
      parsed.hostname = segments.join(".");
    }

    parsed.pathname = "";
    parsed.search = "";
    parsed.hash = "";

    return normalizeUrl(parsed.toString());
  } catch {
    return LOCAL_INTERNAL_APP_URL;
  }
}

export function resolveInternalLoginUrl(currentUrl?: string) {
  return `${resolveInternalAppUrl(currentUrl)}/login`;
}
